module.exports = __webpack_public_path__ + "static/media/notify.be634e68.wav";